import Http from '@/services/HttpApi';

export default class BaseRestApi {
  constructor() {
    if (!this.resource) {
      throw new Error('Le service Rest doit fournir sa ressource');
    }
  }

  getApi() { // eslint-disable-line
    return Http.getAxios();
  }
}
